<form [formGroup]="bookingFilterForm">
    <p-toast position="top-right" key="error-messages-toast"></p-toast>


    <!--Start: PRIME - NG Responsive Dialog Box - Detailed Filter Options-->

    <p-dialog [(visible)]="displayDetailedFilter" header="Filter Bookings" [blockScroll]="true" [modal]="true"
              (onShow)="getSIBookingsCounts(bookingFilterForm?.value?.businessEntityId);"
              [showHeader]="true"
              [draggable]="false"
              [breakpoints]="{'1440px': '50%' ,'1024px': '50%','960px': '50%', '640px': '90%'}"
              [style]="{width: '25%'}">

        <div class="p-d-flex p-jc-center p-ai-center">
            <div>
                <div class="p-grid">
                    <!--                    From Date-->
                    <div class="p-col-6 p-py-3">
                        <p-calendar [baseZIndex]="100" [readonlyInput]="true" [monthNavigator]="true" appendTo="body"
                                    [yearNavigator]="true" yearRange="2000:2030" dateFormat="dd-mm-yy"
                                    class="fp-calendar"
                                    showButtonBar="true" styleClass="width-100" [showIcon]="true"
                                    formControlName="fromDate"
                                    placeholder="From Date">
                        </p-calendar>
                    </div>
                    <!--                    To Date-->
                    <div class="p-col-6 p-py-3">
                        <p-calendar [readonlyInput]="true" [monthNavigator]="true"
                                    [yearNavigator]="true" yearRange="2000:2030" dateFormat="dd-mm-yy"
                                    class="fp-calendar"
                                    appendTo="body"
                                    showButtonBar="true" styleClass="width-100" [showIcon]="true"
                                    formControlName="toDate"
                                    placeholder="To Date"></p-calendar>
                    </div>

                    <div class="p-col-12 p-py-3">
                        <input type="text" formControlName="customerReferenceNumber" pInputText class="width-100"
                               placeholder="Customer Reference Number"/>
                    </div>

                    <div class="p-col-12 p-py-3">
                        <p-dropdown [showClear]="true" styleClass="width-100" filterBy="portName" [filter]="true"
                                    [options]="ports"
                                    appendTo="body"
                                    placeholder="Origin" optionLabel="portName"
                                    formControlName="loadPort"
                                    optionValue="portCode"></p-dropdown>
                    </div>

                    <div class="p-col-12 p-py-3">
                        <p-dropdown [showClear]="true" styleClass="width-100" filterBy="portName" [filter]="true"
                                    [options]="ports"
                                    appendTo="body"
                                    placeholder="Destination" optionLabel="portName"
                                    formControlName="dischargePort"
                                    optionValue="portCode"></p-dropdown>
                    </div>

                    <div class="p-col-6 p-py-3 p-text-right">
                        <button pButton class="button-height p-px-5 p-button-info" (click)="onSubmitBookingFilterForm()"
                                label="Apply"
                        ></button>
                    </div>
                    <div class="p-col-6 p-py-3 p-text-left">
                        <button pButton class="button-height p-px-5 p-button-info p-button-outlined"
                                (click)="resetBookingFilterForm()" label="Clear"
                        ></button>
                    </div>
                </div>

                <div class="p-grid divider-top p-pt-3">
                    <div class="p-col-6 p-text-center">
                        <button [icon]="bookingFilterForm?.value.submittedSI ? 'pi pi-check' : null"
                                (click)="bookingFilterForm?.controls.submittedSI.setValue(true);
                                bookingFilterForm?.controls.draftSI.setValue(false);
                                bookingFilterForm?.controls.activeOnly.setValue(true);
                                onSubmitBookingFilterForm()"
                                style="min-width: 10rem;" pButton pRipple class="p-button-info"
                                [label]="'Submitted SI (' +  (siCounts?.submittedSI ? siCounts?.submittedSI : 0)  + ')'"></button>
                    </div>

                    <div class="p-col-6 p-text-center">
                        <button
                                (click)="bookingFilterForm?.controls.draftSI.setValue(true);
                                bookingFilterForm?.controls.submittedSI.setValue(false);
                                bookingFilterForm?.controls.activeOnly.setValue(true); onSubmitBookingFilterForm()"
                                [icon]="bookingFilterForm?.value.draftSI ? 'pi pi-check' : null"
                                style="min-width: 10rem;" pButton pRipple class="p-button-info"
                                [label]="'Draft SI (' +  (siCounts?.draftSI ? siCounts?.draftSI : 0) + ')'"></button>
                    </div>
                </div>
            </div>
        </div>

    </p-dialog>

    <!--End: PRIME - NG Responsive Dialog Box - Detailed Filter Options-->


    <!--    Start: Loader For Api Response-->

    <div class="p-text-center" *ngIf="isLoading">
        <div class="p-text-center">
            <div>
                <i class="p-text-secondary pi pi-spin pi-spinner" style="font-size: 2rem;"></i>
            </div>
            <div class="p-mt-3">
                <h5 class="p-text-secondary">Loading !</h5>
            </div>
        </div>
    </div>

    <!--    End: Loader For Api Response-->

    <!--    Start: Filter Option's Header-->

    <div *ngIf="!isLoading">

        <div class="p-grid p-ai-center">

            <!--Search Booking Number / BL Number-->

            <div class="p-col-12 p-xl-4">
                    <span class="p-input-icon-right p-float-label width-100">
                        <input (change)="onSearchOfBookingOrBLNumber()" formControlName="filterByIdentifier" type="text"
                               pInputText class="width-100"/>
                        <label>Booking, Container, BL,AWBL</label>
						<i class="pi pi-search"></i>
					</span>
            </div>

            <!--            Dummy Column For Spacing and Matched UX-->

            <div class="p-col-1">

            </div>

            <!--            OrderTypes, Detailed Filter Options Button, Active / Delivered-->
            <div class="p-col-12 p-xl-7">
                <div class="p-d-block p-d-md-flex p-jc-between p-jc-xl-end p-ai-center">
                    <div>
                        <!--                        OrderTypes Selection-->
                        <p-multiSelect (onPanelHide)="onSubmitBookingFilterForm('shipmentType')" #orderTypeSelection
                                       class="order-type-selection" optionValue="orderTypeDescription"
                                       styleClass="width-100"
                                       optionLabel="orderTypeDescription"
                                       [options]="orderTypes"
                                       [placeholder]="'All'"
                                       formControlName="orderTypes">
                            <ng-template pTemplate="header">

                                <div class="apply-button p-ai-center">
                                    <button class="apply-button-size check-button-size" type="button"
                                            (click)="onSubmitBookingFilterForm(); orderTypeSelection.close($event)"
                                            pButton pRipple type="button" icon="pi pi-check"></button>
                                </div>

                            </ng-template>
                        </p-multiSelect>
                    </div>

                    <div class="p-d-flex p-md-block p-jc-between p-mt-4 p-mt-md-0">
                        <div class="p-ml-0 p-ml-md-4 p-as-center">
                            <div>
                                <button pButton pRipple label="Active" type="button"
                                        (click)="bookingFilterForm?.controls.activeOnly.setValue(true); onSubmitBookingFilterForm()"
                                        [class]="bookingFilterForm?.value?.activeOnly === null ? 'p-button-not-selected p-button-info p-button-outlined active-button p-text-bold' : bookingFilterForm?.value?.activeOnly ? 'p-button-secondary active-button p-border-secondary p-text-bold' : 'p-button-not-selected p-button-info p-button-outlined active-button p-text-bold'">
                                </button>
                                <button pButton pRipple label="Delivered" type="button"
                                        (click)="bookingFilterForm?.controls.activeOnly.setValue(false); onSubmitBookingFilterForm()"
                                        [class]="bookingFilterForm?.value?.activeOnly === null ? 'p-button-not-selected p-button-info p-button-outlined delivered-button p-text-bold' : !bookingFilterForm?.value?.activeOnly ? 'p-button-secondary delivered-button p-border-secondary p-text-bold' : 'p-button-not-selected p-button-info p-button-outlined delivered-button p-text-bold '">
                                </button>
                            </div>
                        </div>

                        <div class="p-ml-0 p-ml-md-4 p-as-center">
                            <!--                            Detailed Filter Options Button-->
                            <img class="p-cursor" (click)="displayDetailedFilter = true"
                                 src="assets/branding/shared-icons/filter-secondary.svg" alt="" pRipple
                                 style="height: calc(2rem + 1vmin);">
                        </div>
                    </div>
                </div>
            </div>

        </div>
        <div class="p-grid p-mt-2 p-ai-center p-jc-start" *ngIf="isAdmin">
            <div class="p-col-12 p-xl-4">
                <div class="p-field">
                    <p-dropdown (onChange)="applyCustomerFilter()" [filter]="true"
                                [options]="customers"
                                [showClear]="bookingFilterForm?.value?.businessEntityId?.length > 0"
                                appendTo="body"
                                emptyFilterMessage="Filtered Value not found"
                                emptyMessage="No Customers Found"
                                filterBy="name"
                                formControlName="businessEntityId"
                                optionValue="businessEntityId"
                                optionLabel="name"
                                placeholder="Select Customer..">
                        <ng-template let-customer pTemplate="items">
                            {{customer?.name}}
                        </ng-template>
                    </p-dropdown>
                </div>
            </div>
        </div>

    </div>

    <!--    End: Filter Option's Header-->

</form>
